/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MaxInputs */

const en_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const es_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máx.`)
};

const fr_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const de_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const ja_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大`)
};

const zh_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大`)
};

const ar_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأقصى`)
};

const id_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maks`)
};

const it_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const ru_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Макс`)
};

const pt_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máx`)
};

const ko_max = /** @type {(inputs: MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대`)
};

/**
* | output |
* | --- |
* | "Max" |
*
* @param {MaxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const max = /** @type {((inputs?: MaxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MaxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_max(inputs)
	if (locale === "es") return es_max(inputs)
	if (locale === "fr") return fr_max(inputs)
	if (locale === "de") return de_max(inputs)
	if (locale === "ja") return ja_max(inputs)
	if (locale === "zh") return zh_max(inputs)
	if (locale === "ar") return ar_max(inputs)
	if (locale === "id") return id_max(inputs)
	if (locale === "it") return it_max(inputs)
	if (locale === "ru") return ru_max(inputs)
	if (locale === "pt") return pt_max(inputs)
	return ko_max(inputs)
});